exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classes---input---3xLS1 {\n  padding-top: 0px; }\n", ""]);

// exports
exports.locals = {
	"input": "classes---input---3xLS1"
};